export default __webpack_public_path__ + "static/media/SWT0080.34I-21240_-14883_0.87d054a7.jpg";